// incident.helper.ts
import { type IncidentDto } from "src/types/incidentDto";

const VALID_TYPES = new Set(["maintenance", "incident"]);

export function isValidIncident(item: unknown): item is IncidentDto {
  if (!item || typeof item !== "object") return false;
  const i = item as Record<string, unknown>;
  return (
    VALID_TYPES.has(i.type as string) &&
    Array.isArray(i.namespace) &&
    i.namespace.every((n) => typeof n === "string") &&
    typeof i.startTS === "string" && i.startTS.length > 0 &&
    typeof i.endTS === "string" && i.endTS.length > 0 &&
    typeof i.title === "string" && i.title.length > 0 &&
    typeof i.message === "string"
  );
}